
import { defineComponent } from "vue";
import ResetPassword from "../../components/Authentication/ResetPassword/ResetPassword.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "ResetPasswordPage",
  components: {
    ResetPassword,
    MainFooter,
  },
});
